module.exports = __webpack_public_path__ + "static/media/Advanced Package.8a04b878.pdf";